export default __webpack_public_path__ + "static/media/chevron_down_arrow.d8a0f75b.svg";